var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"divider-section",class:[
		_vm.styles && [
			_vm.styles.justifyContent ? _vm.styles.justifyContent : '',
			_vm.styles.textAlign ? _vm.styles.textAlign : '',
			_vm.styles.alignItems ? _vm.styles.alignItems : '' ] ],style:(_vm.styles && [_vm.styles.bgType == 'color' ? _vm.backgroundColor : _vm.backgroundImage, _vm.fontColor])},[_c('SanityBlockContent',{staticClass:"py-6",attrs:{"blocks":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }